export const setCookie = (name, value, hours, domain) => {
  let expires = "";
  if (hours) {
    let date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  domain = domain ?? window.cookiesDomain ?? window.location.hostname;
  document.cookie = `${name}=${value || ""}${expires};domain=${domain};path=/`;
}

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookies = decodeURIComponent(document.cookie);
  let cookies = decodedCookies.split(';');
  for (const cookie of cookies) {
    let c = cookie.trim();
    if (c.startsWith(name)) {
      return c.substring(name.length);
    }
  }
  return undefined;
}

export const removeCookie = (name) => {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
